import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import NbnlTncContent from './NbnlTncContent';
import NbnlNotSupportedContent from './NbnlNotSupportedContent';

export default function FeatureModal({
  isOpen = false,
  onClose = () => {},
  isProcessing = false,
  isUpsSupported = true,
  title = '',
  onAcceptTerms = () => {},
  agreeTerms = false,
  setAgreeTerms = () => {}
}) {
  return (
    <UiKit.Modal
      centered
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title={title} />
      <UiKit.Modal.Body className={styles.modalBody}>
        <If test={isUpsSupported} otherwise={<NbnlNotSupportedContent />}>
          <NbnlTncContent
            agreeTerms={agreeTerms}
            setAgreeTerms={setAgreeTerms}
          />
        </If>
      </UiKit.Modal.Body>
      <If test={isUpsSupported}>
        <UiKit.Modal.Footer
          onConfirm={() => onAcceptTerms()}
          confirmBtnText={'Agree'}
          isDisabled={!agreeTerms}
        />
      </If>
    </UiKit.Modal>
  );
}
